<template>
  <v-dialog persistent v-model="dialog" max-width="800px">
    <v-btn
      color="primary"
      slot="activator"
    >
      Neuen Gast hinzufügen
    </v-btn>
    <v-card>
      <v-card-title class="primary">
        <span class="headline white--text">Gast hinzufügen</span>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-layout wrap>
              <v-flex xs12>
                <v-select
                  :items="ceos"
                  item-text="company"
                  required
                  item-value="id"
                  v-model="guest.ceoId"
                  :rules="[v => !!v || 'Dies ist ein Pflichtfeld']"
                  label="Unternehmen"
                ></v-select>
              </v-flex>
              <v-flex xs6>
                <v-select
                  :items="genders"
                  v-model="guest.gender"
                  label="Anrede"
                  single-line
                  :disabled="loading"
                ></v-select>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  label="Titel"
                  v-model="guest.title"
                  :disabled="loading"></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  label="Vorname"
                  v-model="guest.forename"
                  :disabled="loading"></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  label="Nachname"
                  v-model="guest.surname"
                  :disabled="loading"></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  label="Email"
                  required
                  v-model="guest.email"
                  :rules="emailRules"
                  :disabled="loading"></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-switch
                  :label="`Per ${guest.formal ? 'Sie' : 'Du'}`"
                  v-model="guest.formal"
                  :disabled="loading"
                ></v-switch>
              </v-flex>
            </v-layout>
          </v-form>
        </v-container>
        <small>*Pflichtfelder</small>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" flat @click.native="cancel()">Abbrechen</v-btn>
        <v-btn color="primary" @click.native="save()" :loading="loading">Hinzufügen</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';

  export default {
    name: 'DialogCreateTrainingGuest',
    data() {
      return {
        dialog: false,
        valid: true,
        guest: {},
        companies: null,
        loading: false,
        emailRules: [
          (v) => !!v || 'Dies ist ein Pflichtfeld',
          (v) => /.+@.+/.test(v) || 'E-mail Adresse ungültig',
        ],
        genders: [
          {
            text: 'Weiblich',
            value: 'female',
          },
          {
            text: 'Männlich',
            value: 'male',
          },
        ],
      };
    },
    computed: {
      ...mapGetters({
        training: 'admin/trainings/one',
        newGuest: 'admin/guests/one',
        ceos: 'admin/ceos/all',
      }),
    },
    methods: {
      ...mapActions({
        createGuest: 'admin/guests/create',
        readGuests: 'admin/guests/read',
        addGuest: 'admin/trainings/addGuest',
        readTraining: 'admin/trainings/readOne',
        readCeos: 'admin/ceos/read',
      }),
      save() {
        if (this.$refs.form.validate()) {
          this.loading = true;
          this.createGuest(this.guest)
            .then(() => this.addGuest({ training: this.training.training, guest: this.newGuest }))
            .then(() => this.readTraining(this.training.training))
            .then(() => {
              this.loading = false;
              this.dialog = false;
            });
        }
      },
      cancel() {
        this.dialog = false;
        this.guest = { };
      },
    },
    mounted() {
      this.readCeos();
    },
  };
</script>

<style scoped>

</style>
